/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var PropTypes = require("prop-types");
var React = require("react");
var classnames = require("classnames");
if (!process.env.ALEX_UI_IGNORE_CSS) { require('./Input.css'); }
var Label_1 = require("./Label");
var ErrorMessage_1 = require("./ErrorMessage");
var addAriaAttributes_1 = require("./util/addAriaAttributes");
var Icon_1 = require("./Icon");
var moduleClassNameFactory_1 = require("./util/moduleClassNameFactory");
var moduleClassName = moduleClassNameFactory_1.moduleClassNameFactory("m-input");
var Input = /** @class */ (function (_super) {
    tslib_1.__extends(Input, _super);
    function Input(props) {
        var _this = _super.call(this, props) || this;
        _this.handleChange = _this.handleChange.bind(_this);
        _this.handleBlur = _this.handleBlur.bind(_this);
        _this.handleFocus = _this.handleFocus.bind(_this);
        _this.handleKeyUp = _this.handleKeyUp.bind(_this);
        _this.handleKeyDown = _this.handleKeyDown.bind(_this);
        _this.handleIconClick = _this.handleIconClick.bind(_this);
        return _this;
    }
    Input.prototype.handleChange = function (e) {
        if (!this.props.onChange) {
            return;
        }
        if (this.props.onBeforeChange) {
            this.props.onChange(e, this.props.onBeforeChange(e.target.value));
        }
        else {
            this.props.onChange(e, e.target.value);
        }
    };
    Input.prototype.handleBlur = function (e) {
        if (this.props.onBlur) {
            this.props.onBlur(e, e.target.value);
        }
    };
    Input.prototype.handleFocus = function (e) {
        if (this.props.onFocus) {
            this.props.onFocus(e, e.target.value);
        }
    };
    Input.prototype.handleKeyUp = function (e) {
        if (this.props.onKeyUp) {
            this.props.onKeyUp(e, e.target.value);
        }
    };
    Input.prototype.handleKeyDown = function (e) {
        if (this.props.onKeyDown) {
            this.props.onKeyDown(e, e.target.value);
        }
    };
    Input.prototype.handleIconClick = function (e) {
        if (this.props.onIconClick) {
            this.props.onIconClick(e);
        }
    };
    Input.prototype.renderLink = function () {
        var _a = this.props, link = _a.link, onLinkClick = _a.onLinkClick;
        if (!link) {
            return null;
        }
        if (typeof link === "string") {
            return (React.createElement("a", { href: "#", onClick: onLinkClick, className: moduleClassName("link") }, link));
        }
        return link;
    };
    Input.prototype.shouldRenderLeftIcon = function () {
        var _a = this.props, readOnly = _a.readOnly, iconLeftType = _a.iconLeftType;
        return readOnly || !!iconLeftType;
    };
    Input.prototype.renderLeftIcon = function () {
        if (this.shouldRenderLeftIcon()) {
            var iconLeftType = this.props.iconLeftType;
            return (React.createElement(Icon_1.Icon, { type: iconLeftType ? iconLeftType : "lock", className: moduleClassName("leftIcon") }));
        }
        return null;
    };
    Input.prototype.render = function () {
        var _a;
        var _b = this.props, id = _b.id, children = _b.children, _c = _b.type, type = _c === void 0 ? "text" : _c, label = _b.label, _d = _b.TagName, TagName = _d === void 0 ? "input" : _d, name = _b.name, title = _b.title, placeholder = _b.placeholder, disabled = _b.disabled, readOnly = _b.readOnly, renderInput = _b.renderInput, maxLength = _b.maxLength, isValid = _b.isValid, hasInfo = _b.hasInfo, hasWarning = _b.hasWarning, triggerInputPulseAnimation = _b.triggerInputPulseAnimation, errorMessage = _b.errorMessage, errorMessageCentered = _b.errorMessageCentered, onClick = _b.onClick, iconType = _b.iconType, iconLeftType = _b.iconLeftType, link = _b.link, onLinkClick = _b.onLinkClick, onMouseLeave = _b.onMouseLeave, onMouseEnter = _b.onMouseEnter, onTouchStart = _b.onTouchStart, defaultValue = _b.defaultValue, value = _b.value, standalone = _b.standalone, autoCorrect = _b.autoCorrect, autoComplete = _b.autoComplete, autoCapitalize = _b.autoCapitalize, autoFocus = _b.autoFocus, inputRef = _b.inputRef, inputClassName = _b.inputClassName, tabIndex = _b.tabIndex;
        var className = classnames(inputClassName, (_a = {},
            _a[moduleClassName("hasInfo")] = hasInfo,
            _a[moduleClassName("hasWarning")] = hasWarning,
            _a[moduleClassName("triggerInputPulseAnimation")] = triggerInputPulseAnimation,
            _a[moduleClassName("isValid")] = isValid,
            _a));
        var inputProps = addAriaAttributes_1.addAriaAttributes({
            onChange: this.handleChange,
            onBlur: this.handleBlur,
            onFocus: this.handleFocus,
            onKeyUp: this.handleKeyUp,
            onKeyDown: this.handleKeyDown,
            onClick: onClick,
            id: id,
            type: type,
            name: name,
            title: title,
            placeholder: placeholder,
            disabled: disabled,
            readOnly: readOnly,
            maxLength: maxLength,
            onMouseLeave: onMouseLeave,
            onMouseEnter: onMouseEnter,
            onTouchStart: onTouchStart,
            autoCorrect: autoCorrect,
            autoComplete: autoComplete,
            autoCapitalize: autoCapitalize,
            autoFocus: autoFocus,
            defaultValue: defaultValue,
            tabIndex: tabIndex,
            value: value,
            ref: inputRef,
            className: classnames(moduleClassName("element"), !!iconType && !readOnly && moduleClassName("hasIcon"), this.shouldRenderLeftIcon() && moduleClassName("hasIconLeft"), className)
        }, this.props);
        if (TagName === "textarea") {
            delete inputProps.type;
        }
        return (React.createElement("div", { className: classnames(moduleClassName(), !!standalone && moduleClassName("isStandalone"), moduleClassName(name)) },
            (!!label || !!link) && (React.createElement(Label_1.Label, { htmlFor: id, label: label, link: link, onLinkClick: onLinkClick })),
            React.createElement("div", { className: moduleClassName("elementWrapper") },
                this.renderLeftIcon(),
                !!renderInput ? (renderInput(inputProps)) : (React.createElement(TagName, tslib_1.__assign({}, inputProps))),
                errorMessage && (React.createElement(ErrorMessage_1.ErrorMessage, { isInfo: hasInfo, isCentered: errorMessageCentered }, errorMessage)),
                !!iconType && !readOnly && (React.createElement("a", { href: "#", className: moduleClassName("iconLink"), role: "button", onClick: this.handleIconClick },
                    React.createElement(Icon_1.Icon, { type: iconType }))),
                children)));
    };
    Input.displayName = "Input";
    Input.propTypes = {
        id: PropTypes.string.isRequired,
        type: PropTypes.string.isRequired,
        TagName: PropTypes.oneOf(["input", "textarea"]),
        renderInput: PropTypes.func,
        label: PropTypes.string,
        link: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
        inputRef: PropTypes.func,
        name: PropTypes.string.isRequired,
        title: PropTypes.string,
        placeholder: PropTypes.string,
        required: PropTypes.bool,
        disabled: PropTypes.bool,
        readOnly: PropTypes.bool,
        maxLength: PropTypes.number,
        iconType: PropTypes.oneOf(Icon_1.IconTypesArray),
        iconLeftType: PropTypes.oneOf(Icon_1.IconTypesArray),
        isValid: PropTypes.bool,
        hasInfo: PropTypes.bool,
        hasWarning: PropTypes.bool,
        triggerInputPulseAnimation: PropTypes.bool,
        errorMessage: PropTypes.string,
        errorMessageCentered: PropTypes.bool,
        value: PropTypes.any,
        defaultValue: PropTypes.any,
        standalone: PropTypes.bool,
        onChange: PropTypes.func,
        onBeforeChange: PropTypes.func,
        onClick: PropTypes.func,
        onBlur: PropTypes.func,
        onFocus: PropTypes.func,
        onKeyUp: PropTypes.func,
        onKeyDown: PropTypes.func,
        onMouseEnter: PropTypes.func,
        onMouseLeave: PropTypes.func,
        onTouchStart: PropTypes.func,
        onLinkClick: PropTypes.func,
        inputClassName: PropTypes.string,
        autoCorrect: PropTypes.string,
        autoComplete: PropTypes.string,
        autoCapitalize: PropTypes.string,
        autoFocus: PropTypes.bool,
        onIconClick: PropTypes.func
    };
    Input.defaultProps = {
        TagName: "input"
    };
    return Input;
}(React.Component));
exports.Input = Input;